import { render, staticRenderFns } from "./classroom.vue?vue&type=template&id=7da8f5b1&"
import script from "./classroom.vue?vue&type=script&lang=js&"
export * from "./classroom.vue?vue&type=script&lang=js&"
import style0 from "./classroom.vue?vue&type=style&index=0&id=7da8f5b1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports